import * as User from '../../constants/User/ProfileEdit'
import axios from 'axios'
import * as SG from '../../constants/AppSettings'
import { signInCheck, noticeAdd, loadEnd, loadStart } from '../App'

export function noticeInEdit(msg, type) {
  return dispatch => {
    dispatch(noticeAdd(msg, type))
  }
}

export function updateMyProfile(formData) {
  return dispatch => {
    dispatch(loadStart())

    if (!formData['user[photo]']) {
      delete formData['user[photo]']
    }

    axios.put(SG.USER_UPDATE_URL, formData, {
      'headers': {
        'Authorization': localStorage.getItem('token'),
        'content-type': 'multipart/form-data'
      }
    })
      .then(function (r) {
        dispatch(signInCheck())
        dispatch(loadEnd())
        dispatch(noticeAdd(`プロフィールを更新しました！`, 'success'))
        // console.log('プロフィール更新', r)
        return {
          type: User.UPDATE_PROFILE
        }
      })
      .catch(function (r) {
        // console.log('プロフィール更新失敗', r, r.response, r.data)
        dispatch(loadEnd())
        if (r.response && r.response.data.messages && r.response.data.messages.length > 0) {
          dispatch(noticeAdd(`${r.response.data.messages}`, 'error'))
        } else if (r.data && r.data.messages && r.data.messages.length > 0) {
          dispatch(noticeAdd(`${r.data.messages}`, 'error'))
        } else {
          dispatch(noticeAdd('プロフィールが更新できませんでした', 'error'))
        }
        
        return {
          type: User.UPDATE_PROFILE
        }
      });

  }
}


// WEBPACK FOOTER //
// ./src/actions/User/ProfileEdit.js